import type { FieldDefinition } from '@/react-query/videa-notes/useVoiceNoteFields';

export const formatFieldKeyForDisplay = (key: string): string =>
  key
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

export const hasDefaultValue = (field: FieldDefinition): boolean =>
  field.defaultValue !== undefined && field.defaultValue !== null;

export const getDefaultValueDisplay = (field: FieldDefinition): string =>
  hasDefaultValue(field) ? String(field.defaultValue) : '';
